import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useGetCatalogQuery } from '@platform/state/api';
import { expertSourcesOf } from './expertSources';
import type { IExpertAdviceProps } from './IExpertAdviceProps';
import { useSourceItems } from './useSourceItems';

/**
 * «Поради експертів» (прототип v4 isAdvisory): експертні висновки, далі статті бази знань — рядки-посилання з назвою (600) і джерелом
 * (12px); без жодного запису — «Поки немає експертних висновків чи статей.».
 */
export function ExpertAdvice({ ws }: IExpertAdviceProps) {
  const { t } = useTranslation();
  const { data: catalog } = useGetCatalogQuery({ workspaceId: ws });
  const [first, second] = expertSourcesOf(catalog);
  const items = [...useSourceItems(ws, first), ...useSourceItems(ws, second)];
  return (
    <section className="mp-panel mp-panel--list">
      <strong className="mp-panel__title mp-panel__title--lg">{t('advisory.experts')}</strong>
      {items.map((it) => (
        <Link key={it.id} className="mp-expert" to={it.to}>
          <span className="mp-expert__title">{it.title}</span>
          <span className="mp-expert__src">{it.source}</span>
        </Link>
      ))}
      {!items.length && <span className="mp-panel__empty">{t('modBody.expertsNone')}</span>}
    </section>
  );
}
